<template>
  <div class="pagination-container">
    <button @click="goToPage(1)" :disabled="currentPage === 1 || loading">
      <ChevronDoubleLeft :size="12" />
    </button>

    <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1 || loading">
      <ChevronLeft :size="12" />
    </button>

    <span v-for="page in visiblePages" :key="page">
      <button v-if="page !== '...'" :class="{ active: page === currentPage }" @click="goToPage(page)"
        :disabled="loading">
        {{ page }}
      </button>
      <span v-else>...</span>
    </span>

    <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages || loading">
      <ChevronRight :size="12" />
    </button>

    <button @click="goToPage(totalPages)" :disabled="currentPage === totalPages || loading">
      <ChevronDoubleRight :size="12" />
    </button>
  </div>
</template>

<script>
import ChevronLeft from 'icons/ChevronLeft'
import ChevronDoubleLeft from 'icons/ChevronDoubleLeft'
import ChevronRight from 'icons/ChevronRight'
import ChevronDoubleRight from 'icons/ChevronDoubleRight'

export default {
  name: 'Pagination',
  components: {
    ChevronLeft,
    ChevronDoubleLeft,
    ChevronRight,
    ChevronDoubleRight,
  },
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visiblePages() {
      if (this.totalPages <= 3) {
        return Array.from({ length: this.totalPages }, (_, i) => i + 1)
      } else if (this.currentPage <= 2) {
        return [1, 2, 3, '...', this.totalPages]
      } else if (this.currentPage >= this.totalPages - 1) {
        return [this.totalPages - 2, this.totalPages - 1, this.totalPages]
      } else {
        return [this.currentPage - 1, this.currentPage, this.currentPage + 1, '...', this.totalPages]
      }
    }
  },
  methods: {
    goToPage(page) {
      if (page === '...') return
      if (page >= 1 && page <= this.totalPages && !this.loading) {
        this.$emit('page-changed', page)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-container {
  display: flex;
  align-items: center;
  gap: 0.3125rem;

  button {
    all: unset;
    display: flex !important;
    align-items: center !important;
    justify-content: center;
    min-width: 1rem;
    padding: 0 0.25rem;
    height: 1.375rem;
    background: transparent;
    border: 1px solid #F1F1F1;
    border-radius: 6px;

    font-size: 0.625rem;
    font-weight: 600;
    line-height: 2px;
    cursor: pointer;

    span {
      color: #000;
    }

    &.active {
      background-color: #1C2D5A;
      color: #FFF;
    }

    &:not(:disabled):not(.active):hover {
      border-color: #1C2D5A;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
}
</style>
